/* eslint-disable */
import React, { Component, Button } from 'react';
import { connect } from 'react-redux';
import { TrackingTable } from './trackingTable';
import history from '../../../history';
import actions from '../../../actions';
import { withRefreshTableOnFilterChange } from '../common/decorators';

@withRefreshTableOnFilterChange
class TrackingContainer extends Component {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.props.load(currentUrlParams);
    }

    render() {
        let pages = -1;
        let showPaginationBottom = false;
        if (this.props.tracking && this.props.tracking.meta) {
            pages = Math.ceil(this.props.tracking.meta.count / 20);
            showPaginationBottom = this.props.tracking.meta.count > 20;
        }
        const currentUrlParams = new URLSearchParams(history.location.search);
        return (
            <TrackingTable
                data={this.props.tracking.content}
                user={this.props.user}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                notification={this.props.notification}
                history={history}
                trackingMapData={this.props.trackingMap.content}
                fetchingTrackingMapData={this.props.trackingMap.fetching}
                loadTrackingMapData={this.props.loadTrackingMapData}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    if (state.tracking) {
        const newState = {
            ...state.tracking,
            user: state.user,
            trackingMap: state.trackingMap,
        };
        return newState;
    }
    return {
        user: state.user,
        tracking: {
            content: [],
        },
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: searchParams => dispatch(actions.loadTracking(searchParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrackingContainer);
